<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box is-vcentered">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('GRUPOSEXAMELISTA.PROCURAR')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column is-1">
                <div class="is-flex is-justified-between">
                    <router-link
                        v-if="isInRole('exameGrupo-alterar')"
                        :to="{ name: 'grupoexame' }"
                        class="button is-primary"
                        >
                        {{$t('GRUPOSEXAMELISTA.INCLUIR')}}
                    </router-link>
                </div>                
            </div>           
            <div class="column">
                <b-switch v-model="exibirGrupoOutrasDespesas" @change.native="onSwitch">
                    <template v-if="!exibirGrupoOutrasDespesas">
                        {{$t('GRUPOSEXAMELISTA.EXIBIRGRUPOSOUTRASDESPESAS')}}
                    </template>
                    <template v-else>
                        {{$t('GRUPOSEXAMELISTA.EXIBIRGRUPOSDEEXAMES')}}
                    </template>
                </b-switch>
            </div>
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('GRUPOSEXAMELISTA.CODIGO')"
                                 v-model="id"
                                 type="number"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('GRUPOSEXAMELISTA.PROXPAGINA')"
                 :aria-previous-label="$t('GRUPOSEXAMELISTA.PAGANTERIOR')"
                 :aria-page-label="$t('GRUPOSEXAMELISTA.PAGINA')"
                 :aria-current-label="$t('GRUPOSEXAMELISTA.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template  @click="abrirCadastro(props.row.id)">
                <b-table-column v-slot="props" field="id" :label="$t('GRUPOSEXAMELISTA.ID')" sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="Nome" :label="$t('GRUPOSEXAMELISTA.NOME')" sortable>
                    {{ props.row.nome }}
                </b-table-column>

                <b-table-column v-slot="props" field="GrupoItens" :label="$t('GRUPOSEXAMELISTA.EXAME')"  width="50%" sortable>
                    {{ props.row.items}}
                </b-table-column>                

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'grupoexame', params: { id: props.row.id }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? '',
                ordenarPor: 'Nome',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null,
                exibirGrupoOutrasDespesas: false,
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    this.$t('GRUPOSEXAMELISTA.MANUTENCAO'),
                    this.$t('GRUPOSEXAMELISTA.GRUPOEXAME'),
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `exibirGrupoOutrasDespesas=${this.exibirGrupoOutrasDespesas}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/manutencao/exameGrupos?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.model?.lista?.forEach(i => {
                            const items = i.grupoItens?.map(gi => gi.apelido)
                            i.items = items?.join(' ');
                        })
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                        this.$router.replace({query: {procurar: this.procurar, page: this.page }})
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {
                this.$router.push({ path: `/manutencao/examegrupo/${this.selecionado.id}` })
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/manutencao/examegrupo/${this.id}` })
            },
            onSwitch(){
                this.loadAsyncData();
            }
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>